/**
 * @generated SignedSource<<d302a35ea57c27c3dab330651aee3396>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUploadImageLinkMutation$variables = Record<PropertyKey, never>;
export type useUploadImageLinkMutation$data = {
  readonly uploadImageLink: {
    readonly image: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
    };
    readonly url: string;
  } | null;
};
export type useUploadImageLinkMutation = {
  response: useUploadImageLinkMutation$data;
  variables: useUploadImageLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useUploadImageLinkMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UploadImageLinkResponse",
        "kind": "LinkedField",
        "name": "uploadImageLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Image_image"
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useUploadImageLinkMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UploadImageLinkResponse",
        "kind": "LinkedField",
        "name": "uploadImageLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbhash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "sizes",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urlExpiresAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "deff8799e50493d089abd73a2485c222",
    "id": null,
    "metadata": {},
    "name": "useUploadImageLinkMutation",
    "operationKind": "mutation",
    "text": "mutation useUploadImageLinkMutation {\n  uploadImageLink {\n    image {\n      id\n      ...Image_image\n    }\n    url\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n"
  }
};
})();

(node as any).hash = "090e92ba1750b97fcb1ae82ebb4c7046";

export default node;
